import axios from 'axios'
import querystring from 'querystring'

// initial state

const state = {
  all: [],
  details: null,
  members: null,
  representatives: {
    president: [],
    nationalCoaches: [],
    officials: []
  },
  dojos: null
}

// getters
const getters = {
  list: state => state.all,
  details: state => state.details,
  members: state => state.members,
  representatives: state => state.representatives,
  dojos: state => state.dojos,
  flagsPath: (state, getters, rootState, rootGetters) => rootGetters['config'].API.flagsPath
}

// actions
const actions = {
  getAll: function (context) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getCountries,
    // formData NO NATIVE SUPPORT
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password
      })
    )
    .then(
      (response) => {
        context.commit('SET_ALL', response.data)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getDetails: function (context, id) {
    context.commit('SET_DETAILS', {})
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getCountryById,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        id: id
      })
    )
    .then(
      (response) => {
        context.commit('SET_DETAILS', response.data.country[0])
        console.log('setting details..')
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getMembers: function (context, id) {
    context.commit('SET_MEMBERS', [])
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getMembersByCountryId,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        countryId: id
      })
    )
    .then(
      (response) => {
        context.commit('SET_MEMBERS', response.data)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getRepresentatives: function (context, id) {
    var reps = {
      president: [],
      nationalCoaches: [],
      officials: []
    }
    context.commit('SET_REPRESENTATIVES', reps)
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getCountryOfficialsByCountryId,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        countryId: id
      })
    )
    .then(
      (response) => {
        context.commit('SET_REPRESENTATIVES', response.data)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getDojos: function (context, id) {
    context.commit('SET_DOJOS', [])
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getDojosByCountryId,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        id: id
      })
    )
    .then(
      (response) => {
        context.commit('SET_DOJOS', response.data.dojos)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  }
}

// mutations
const mutations = {
  SET_ALL (state, data) {
    state.all = data.countries
    console.log('SET_COUNTRIES')
    console.log(state.all)
  },
  SET_DETAILS (state, data) {
    state.details = data
    console.log('SET_DETAILS')
    console.log(state.details)
  },
  SET_MEMBERS (state, data) {
    state.members = data.members
    console.log('SET_MEMBERS')
  },
  SET_REPRESENTATIVES (state, data) {
    state.representatives = data
    console.log('SET_REPRESENTATIVES')
  },
  SET_DOJOS (state, data) {
    state.dojos = data
    console.log('SET_DOJOS')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
